//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
import "../Mechatronics/Mechatronics.EtherNetIPClientBuilder.js";
import "../Mechatronics/Mechatronics.FMUClientBuilder.js";
import "../Mechatronics/Mechatronics.MATLABClientBuilder.js";
import "../Mechatronics/Mechatronics.OPCClientBuilder.js";
import "../Mechatronics/Mechatronics.OPCUAClientBuilder.js";
import "../Mechatronics/Mechatronics.PlcSimAdvClientBuilder.js";
import "../Mechatronics/Mechatronics.ProfinetClientBuilder.js";
import "../Mechatronics/Mechatronics.SHMSignalClientBuilder.js";
import "../Mechatronics/Mechatronics.SinumerikClientBuilder.js";
import "../Mechatronics/Mechatronics.TCPClientBuilder.js";
import "../Mechatronics/Mechatronics.UDPSignalClientBuilder.js";
let d=[[[1,"EtherNetIPClient",0,"Mechatronics.EtherNetIPClientBuilder",0],[1,"FMUClient",0,"Mechatronics.FMUClientBuilder",0],[1,"MatlabClient",0,"Mechatronics.MATLABClientBuilder",0],[1,"OPCDAClient",0,"Mechatronics.OPCClientBuilder",0],[1,"OPCUAClient",0,"Mechatronics.OPCUAClientBuilder",0],[1,"PlcSimAdvClient",0,"Mechatronics.PlcSimAdvClientBuilder",0],[1,"ProfinetClient",0,"Mechatronics.ProfinetClientBuilder",0],[1,"ShmClient",0,"Mechatronics.SHMSignalClientBuilder",0],[1,"SinumerikClient",0,"Mechatronics.SinumerikClientBuilder",0],[1,"TcpClient",0,"Mechatronics.TCPClientBuilder",0],[1,"UdpClient",0,"Mechatronics.UDPSignalClientBuilder",0]],[],[]];
SPLM.Mechatronics.ExternalSignalConfigurationBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.ExternalSignalConfigurationBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;